export default "__VITE_ASSET__IhwV2Rou__"